import { useState, useEffect } from 'react';

import { convertToDisplayFormat, isDateExpired } from '../../../helpers/dateUtils';

/**
 * Custom hook for managing passkey expiration checking logic
 * Handles date format conversion and expiration status checking
 */
export const usePasskeyExpiration = (expirationDate: string): {
  displayExpirationDate: string;
  setDisplayExpirationDate: (value: string) => void;
  isPasskeyExpired: boolean;
  setIsPasskeyExpired: (value: boolean) => void;
} => {
  const [displayExpirationDate, setDisplayExpirationDate] = useState<string>('');
  const [isPasskeyExpired, setIsPasskeyExpired] = useState<boolean>(false);

  /**
   * Converts incoming server date format and checks expiration status
   * Runs when expirationDate prop changes (from server)
   */
  useEffect(() => {
    if (expirationDate) {
      // Convert server format (YYYY/MM/DD) to display format (MM/DD/YYYY)
      const displayDate = convertToDisplayFormat(expirationDate);
      setDisplayExpirationDate(displayDate);

      // Check if passkey is expired
      if (isDateExpired(displayDate)) {
        setIsPasskeyExpired(true);
      }
    }
  }, [expirationDate]);

  return {
    displayExpirationDate,
    setDisplayExpirationDate,
    isPasskeyExpired,
    setIsPasskeyExpired
  };
};
